<template>
  <div>
    <div class="card mb-3" style="width: 100%">
      <!-- <div class="card-header bg-light">
        <h3 class="title fw-normal mb-0 p-2">Signature Information</h3>
      </div> -->
      <div
        class="signature-preview p-4"
        v-if="showPreviewLocal && shouldShowPreview"
      >
        <el-button type="danger" class="p-2" plain @click="editSignature"
          ><i class="el-icon-edit"></i> Edit</el-button
        >
        <div class="el-upload">
          <img :src="getCurrentUserSign" class="img-fluid" />
        </div>
      </div>

      <div class="signature-box" v-loading="verificationLoading" v-else>
        <el-tabs v-model="activeName" class="mt-2">
          <div v-if="reasonMessage" class="alert alert-info mb-3">
            {{ reasonMessage }}
          </div>
          <el-tab-pane
            v-if="
              docSetting.secure_e_sign &&
              docSetting.secure_e_sign.enable_text_signature
            "
            label="Text Signature"
            name="letter"
          >
            <h4 class="font-weight-normal mb-1" v-if="textSignature">
              Current Signature
            </h4>
            <div class="el-upload">
              <img :src="textSignature" class="img-fluid" />
            </div>
            <el-form>
              <el-form-item class="mb-05" label="Select Style">
                <el-select
                  v-model="value"
                  placeholder="Select"
                  @change="onChangeStyle"
                >
                  <el-option
                    v-for="item in outlet"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Signature Text">
                <el-input
                  type="text"
                  v-model="signatureText"
                  label="Signature"
                  placeholder="Enter signature"
                ></el-input>
                <div
                  class="fontsize"
                  :style="{
                    'font-family': tstyle,
                    color: signatureColor,
                    'max-width': '100%',
                  }"
                >
                  {{ signatureText }}
                </div>
              </el-form-item>
            </el-form>
            <div class="my-3">
              <button
                type="button"
                class="color-btn red"
                @click="signatureColor = '#FF0000'"
              ></button>
              <button
                type="button"
                class="color-btn black"
                @click="signatureColor = '#000000'"
              ></button>
              <button
                type="button"
                class="color-btn green"
                @click="signatureColor = '#008000'"
              ></button>
            </div>
          </el-tab-pane>
          <el-tab-pane
            v-if="
              docSetting.secure_e_sign &&
              docSetting.secure_e_sign.enable_draw_signature
            "
            label="Draw Signature"
            name="drawer"
          >
            <el-row>
              <el-col :span="24" v-loading="signatureLoading">
                <h4 class="font-weight-normal mb-1" v-if="drawSignatureImage">
                  Current Signature
                </h4>
                <div class="el-upload">
                  <img :src="drawSignatureImage" height="100px" width="100%" />
                </div>

                <h4 class="font-weight-normal">Update New Signature Here</h4>
                <VueSignaturePad
                  class="sign-image"
                  id="signature"
                  height="75px"
                  width="498px"
                  ref="signaturePad"
                  :options="{
                    penColor,
                    onBegin: () => {
                      $refs.signaturePad.resizeCanvas();
                    },
                  }"
                />
              </el-col>
              <el-col :span="24">
                <el-button
                  class="float-right"
                  icon="el-icon-refresh-left"
                  size="medium"
                  plain
                  round
                  type="danger"
                  title="Undo"
                  @click="undo"
                  >Undo</el-button
                >
                <button
                  type="button"
                  class="color-btn red"
                  @click="setColor($event, 'red')"
                ></button>
                <button
                  type="button"
                  class="color-btn black"
                  @click="setColor($event, 'black')"
                ></button>
                <button
                  type="button"
                  class="color-btn green"
                  @click="setColor($event, 'green')"
                ></button>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane
            v-if="
              docSetting.secure_e_sign &&
              docSetting.secure_e_sign.enable_upload_signature
            "
            label="Upload Signature"
            name="upload"
          >
            <el-row>
              <el-col :span="24">
                <div>
                  <h4
                    class="font-weight-normal mb-1"
                    v-if="uploadSignatureImage"
                  >
                    Current Signature
                  </h4>
                  <div class="el-upload">
                    <img :src="uploadSignatureImage" class="img-fluid" />
                  </div>
                </div>
                <h4 class="font-weight-normal">Update New Signature Here</h4>
                <vue-anka-cropper
                  class="upload-file"
                  :options="{
                    aspectRatio: false,
                    closeOnSave: false,
                    cropArea: 'box',
                    croppedHeight: 1000,
                    croppedWidth: 1000,
                    cropperHeight: false,
                    dropareaMessage:
                      ' Drag & Drop  file here or use the button below.',
                    frameLineDash: [1, 1000],
                    frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
                    handleFillColor: 'rgba(255, 255, 255, 0.2)',
                    handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
                    handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
                    handleSize: 5,
                    handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
                    layoutBreakpoint: 40,
                    maxCropperHeight: 1000,
                    maxFileSize: 8000000,
                    overlayFill: 'rgba(0, 0, 0, 0.5)',
                    previewOnDrag: true,
                    previewQuality: 0.65,
                    resultQuality: 0.8,
                    resultMimeType: 'image/jpeg',
                    resultMimeType: 'image/png',
                    resultMimeType: 'image/jpg',
                    resultMimeType: 'image/gif',
                    selectButtonLabel: 'Files Supported : JPG, PNG, JPEG, GIF',
                    showPreview: true,
                    skin: 'light',
                    uploadData: {},
                    uploadTo: false,
                  }"
                  name="logo"
                  @cropper-error="fileError"
                  @cropper-preview="storeFileToUpload"
                  @cropper-file-selected="storeFileToUpload"
                  @cropper-saved="someAction(cropData)"
                ></vue-anka-cropper>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import textToImage from "text-to-image";
import vueAnkaCropper from "vue-anka-cropper";
import "vue-anka-cropper/dist/VueAnkaCropper.css";
export default {
  name: "signature-MySignatureFromVerificationCode",
  components: { vueAnkaCropper },
  props: {
    docSetting: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showPreviewLocal: true,
      reasonMessage: "",
      textSignature: "",
      drawSignatureImage: "",
      uploadSignatureImage: "",
      empty: true,
      outlet: [
        {
          value: "AndyBold",
          label: "AndyBold",
        },
        {
          value: "ArialRoundedMTBold",
          label: "Arial Rounded MT Bold",
        },
        {
          value: "BickleyScript",
          label: "Bickley Script",
        },
        {
          value: "FreestyleScript",
          label: "Freestyle Script",
        },
        {
          value: "VladimirScript",
          label: "Vladimir Script",
        },
        {
          value: "Mistral",
          label: "Mistral",
        },
        {
          value: "Brush Script MT",
          label: "Brush Script MT",
        },
        {
          value: "Shears",
          label: "Shears",
        },
        {
          value: "Royaliya",
          label: "Royaliya",
        },
        {
          value: "Cookie",
          label: "Cookie",
        },
        {
          value: "Playfair Display",
          label: "Playfair Display",
        },
        {
          value: "Kaushan Script",
          label: "Kaushan Script",
        },
        {
          value: "Arizonia",
          label: "Arizonia",
        },
        {
          value: "Tangerine",
          label: "Tangerine",
        },
        {
          value: "Lucida Handwriting",
          label: "Lucida Handwriting",
        },
        {
          value: "Segoe Script",
          label: "Segoe Script",
        },
        {
          value: "FREESCPT",
          label: "FREESCPT",
        },
        {
          value: "NanumPenScript-Regular",
          label: "NanumPenScript-Regular",
        },
        {
          value: "NothingYouCouldDo-Regular",
          label: "NothingYouCouldDo-Regular",
        },
        {
          value: "RAGE",
          label: "RAGE",
        },
        {
          value: "SignPainterHouseScript",
          label: "SignPainterHouseScript",
        },
        {
          value: "KUNSTLER",
          label: "KUNSTLER",
        },
      ],
      value: "Tangerine",
      activeName: "letter",
      tstyle: "Tangerine",
      signatureText: "",
      signatureColor: "#000",
      penColor: "black",
      unlockSignaturePad: false,
      images: [],
      signatureImage: null,
      signatureLoading: false,
      userSignatureData: {},
      verificationLoading: false,
      showPreview: false,
      signatureType: false,
      authorizeSignatureFormData: {},
      getCurrentUserSign: null,
    };
  },
  computed: {
    ...mapGetters("auth", [
      "getAuthenticatedUser",
      "getSignatureUpdateStatus",
      "getSignatureUpdateErrors",
      "getUserSignature",
    ]),
    ...mapGetters("employeeData", ["getUserSignature"]),
    showTextSignatureInput() {
      return (
        this.docSetting.secure_e_sign?.enable_text_signature &&
        this.activeName === "letter" &&
        !this.getUserSignature?.text_signature
      );
    },
    showDrawSignatureInput() {
      return (
        this.docSetting.secure_e_sign?.enable_draw_signature &&
        this.activeName === "drawer" &&
        !this.getUserSignature?.draw_signature
      );
    },
    showUploadSignatureInput() {
      return (
        this.docSetting.secure_e_sign?.enable_upload_signature &&
        this.activeName === "upload" &&
        !this.getUserSignature?.upload_signature
      );
    },
    shouldShowPreview() {
      const sig = this.getUserSignature || {};
      const conf = (this.docSetting && this.docSetting.secure_e_sign) || {};
      const types = [
        {
          key: "text",
          enabled: conf.enable_text_signature,
          has: !!sig.text_signature,
        },
        {
          key: "draw",
          enabled: conf.enable_draw_signature,
          has: !!sig.draw_signature,
        },
        {
          key: "upload",
          enabled: conf.enable_upload_signature,
          has: !!sig.upload_signature,
        },
      ];

      const enabled = types.filter((t) => t.enabled);
      if (enabled.length === 0) return true;
      if (enabled.length === 1) {
        return enabled[0].has;
      }
      return enabled.some((t) => t.has);
    },
  },
  async mounted() {
    await this.getCurrentUserSignature();
    if (this.getAuthenticatedUser && this.getAuthenticatedUser.signature) {
      this.getCurrentUserSign = this.getAuthenticatedUser.signature;
      this.showPreview = true;
    } else {
      await this.getCurrentUserSignature();
    }
    if (
      this.docSetting.secure_e_sign.enable_text_signature &&
      !this.getUserSignature.text_signature
    ) {
      this.showPreview = false;
      this.activeName = "letter";
    } else if (
      this.docSetting.secure_e_sign.enable_draw_signature &&
      !this.getUserSignature.draw_signature
    ) {
      this.showPreview = false;
      this.activeName = "drawer";
    } else if (
      this.docSetting.secure_e_sign.enable_upload_signature &&
      !this.getUserSignature.upload_signature
    ) {
      this.showPreview = false;
      this.activeName = "upload";
    } else {
      this.showPreview = true;
    }
    this.decideActiveTab();
  },
  methods: {
    editSignature() {
      this.showPreviewLocal = false;
      const configSettings = this.docSetting.secure_e_sign || {};
      if (configSettings.enable_text_signature && !this.textSignature) {
        this.activeName = "letter";
        this.reasonMessage =
          "You enabled text signature but no signature found, please update.";
      } else if (
        configSettings.enable_draw_signature &&
        !this.drawSignatureImage
      ) {
        this.activeName = "drawer";
        this.reasonMessage =
          "You enabled draw signature but no signature found, please update.";
      } else if (
        configSettings.enable_upload_signature &&
        !this.uploadSignatureImage
      ) {
        this.activeName = "upload";
        this.reasonMessage =
          "You enabled upload signature but no signature found, please update.";
      } else {
        if (configSettings.enable_text_signature) {
          this.activeName = "letter";
        } else if (configSettings.enable_draw_signature) {
          this.activeName = "drawer";
        } else if (configSettings.enable_upload_signature) {
          this.activeName = "upload";
        }
      }
    },
    decideActiveTab() {
      const eSign = this.docSetting.secure_e_sign || {};

      if (
        eSign.enable_text_signature &&
        !this.getUserSignature?.text_signature
      ) {
        this.activeName = "letter";
        this.reasonMessage =
          "Text signature is enabled but not yet provided — please add it.";
        return;
      }

      if (
        eSign.enable_draw_signature &&
        !this.getUserSignature?.draw_signature
      ) {
        this.activeName = "drawer";
        this.reasonMessage =
          "Draw signature is enabled but missing — please draw and save your signature.";
        return;
      }

      if (
        eSign.enable_upload_signature &&
        !this.getUserSignature?.upload_signature
      ) {
        this.activeName = "upload";
        this.reasonMessage =
          "Upload signature is enabled but you haven't uploaded one — please upload a file.";
        return;
      }

      this.reasonMessage = "";
    },
    async getCurrentUserSignature() {
      await this.$store.dispatch("employeeData/fetchUserSignature");
      const userSig = this.getUserSignature;
      if (userSig && userSig.signature) {
        this.getCurrentUserSign = userSig.signature;
        this.showPreview = !this.showDrawSignatureInput;
        this.drawSignatureImage = userSig.draw_signature;
        this.textSignature = userSig.text_signature;
        this.uploadSignatureImage = userSig.upload_signature;
      } else {
        this.showPreview = false;
      }
    },
    async onChangeStyle(font) {
      this.tstyle = font;
    },
    async storeFileToUpload(file) {
      this.signatureImage = file;
      setTimeout(() => {
        const doc = document.querySelector(".ankaCropper__previewArea");
        this.signatureImage = doc.querySelector("img").src;
      }, 1000);
    },
    fileError() {
      this.$alert("File Supported:JPG,PNG,JPEG,Gif");
    },
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let signature = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          signature = reader.result;
          // imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(signature);
        };
      });
    },

    toggleSignatureText() {
      if (this.signatureType) {
        this.signatureText = "";
        this.signatureText += this.getAuthenticatedUser.first_name
          ? this.getAuthenticatedUser.first_name[0].toUpperCase()
          : "";
        this.signatureText += this.getAuthenticatedUser.last_name
          ? this.getAuthenticatedUser.last_name[0].toUpperCase()
          : "";
      }
    },
    async saveCapturedSignature() {
      try {
        let type = "text";
        let empty = true;
        console.log("this.signatureText", this.signatureText);
        if (this.activeName == "letter" && this.signatureText) {
          await this.generateTextImage();
          type = "text";
          empty = false;
          console.log("this.signatureImage", this.signatureImage);
          this.textSignature = this.signatureImage;
        }
        if (this.activeName == "drawer") {
          const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
          empty = isEmpty;
          if (!isEmpty) {
            this.signatureImage = data;
            this.drawSignatureImage = data;
          }
          type = "draw";
        }
        if (this.activeName == "upload") {
          type = "upload";
          empty = false;
          console.log("this.signatureImage", this.signatureImage);
          if (this.signatureImage) {
            this.uploadSignatureImage = this.signatureImage;
          }
        }
        if (!empty) {
          this.verificationLoading = true;
          await this.$store.dispatch("auth/updateUserSignature", {
            signature: this.signatureImage,
            signatureDataType: type,
            textSignature: this.textSignature,
            drawSignature: this.drawSignatureImage,
            uploadSignature: this.uploadSignatureImage,
          });
          await this.getCurrentUserSignature();
          this.verificationLoading = false;
        }
        this.$emit("signatureTypeChanged", {
          type: this.activeName,
          textSignature: this.textSignature,
          drawSignature: this.drawSignatureImage,
          uploadSignature: this.uploadSignatureImage,
        });
        if (this.getSignatureUpdateStatus) {
          this.$notify.success({
            title: "Success",
            message: "Signature updated successfully",
          });
          this.showPreview = true;
        } else {
          if (this.getSignatureUpdateErrors) {
            this.$notify.error({
              title: "Error",
              message: "Error in updating signature",
            });
          }
        }
      } catch (err) {
        console.log("saveCapturedSignature", err);
      }
    },

    generateTextImage() {
      // let w = 50;
      let margin = 3;
      let fontSize = 30;
      let lineHeight = 30;
      if (this.tstyle == "FREESCPT") {
        // w = 30;
      } else if (this.tstyle == "NanumPenScript-Regular") {
        // w = 30;
      } else if (this.tstyle == "NothingYouCouldDo-Regular") {
        // w = 40;
        // lineHeight = 50;
        fontSize = 25;
      } else if (this.tstyle == "RAGE") {
        // w = 35;
        lineHeight = 35;
      } else if (this.tstyle == "KUNSTLER") {
        // w = 25;
      } else if (this.tstyle == "Brush Script MT") {
        // w = 45;
      } else if (this.tstyle == "SignPainterHouseScript") {
        lineHeight = 35;
        // w = 30;
      } else if (this.tstyle == "Segoe Script") {
        // w = 30;
        fontSize = 25;
        margin = 5;
      } else if (this.tstyle == "Lucida Handwriting") {
        // w = 35;
        // lineHeight = 35;
        fontSize = 25;
      } else if (this.tstyle == "BickleyScript") {
        fontSize = 45;
      } else if (this.tstyle == "VladimirScript") {
        fontSize = 25;
      } else if (this.tstyle == "KunstlerScript") {
        fontSize = 25;
      } else if (this.tstyle == "Mistral") {
        fontSize = 25;
      } else if (this.tstyle == "Shears") {
        fontSize = 36;
      } else if (this.tstyle == "Royaliya") {
        fontSize = 36;
      } else if (this.tstyle == "Cookie") {
        fontSize = 36;
      } else if (this.tstyle == "Playfair Display") {
        fontSize = 24;
      } else if (this.tstyle == "Kaushan Script") {
        fontSize = 36;
      } else if (this.tstyle == "Arizonia") {
        fontSize = 36;
      } else if (this.tstyle == "Tangerine") {
        fontSize = 30;
      }

      // let imgWidth =
      //   this.signatureText.length * w < 300
      //     ? 300
      //     : this.signatureText.length * w;
      var maxWidth = 250;
      if (this.signatureText.length >= 14) {
        maxWidth = maxWidth + (this.signatureText.length - 13) * 10 + 20;
        // lineHeight = lineHeight + (this.signatureText.length - 14) * 1;
      }

      textToImage
        .generate("  " + this.signatureText, {
          textColor: this.signatureColor,
          fontFamily: this.tstyle,
          maxWidth: maxWidth,
          textAlign: "left",
          verticalAlign: "center",
          fontSize: fontSize,
          // fontFamily: 'Arial',
          lineHeight: lineHeight,
          margin: margin,
          bgColor: "transparent",
          // textColor: 'red',
        })
        .then((dataUri) => {
          this.signatureImage = dataUri;
        });
    },

    setColor(event, color) {
      this.penColor = color;
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
  },
  // beforeDestroy() {
  //   this.$store.commit("employeeData/setUserSignature",null,{root:true})
  // }
};
</script>
<style lang="scss" scoped>
.ankaCropper__navigation a:nth-child(4n + 4) {
  display: none !important;
}
.ankaCropper__navigation a:nth-child(5n + 5) {
  display: none !important;
}
.ankaCropper__saveButton {
  display: none !important;
  padding: 8px 20px;
  font-size: 14px;
}
.fontsize {
  padding: 5%;
  font-size: 40px;
  max-width: 247px;
}
.el-image__error,
.el-image__inner,
.el-image__placeholder {
  width: unset !important;
}
.signature-box {
  display: block;
  max-width: 500px;
  padding: 0 1em;
  margin: 0 0 5px 0;
  .sign-image {
    border: 1px solid #dddddd;

    border-radius: 4px;
    margin-bottom: 3px;
    background-color: rgba(0, 0, 0, 0.025);
    position: relative;
    &:after {
      content: "";
      position: absolute;
      left: 30px;
      right: 30px;
      bottom: 80px;
      height: 1px;
      background-color: #999999;
      z-index: 0;
    }
  }
  .color-btn {
    height: 16px;
    width: 16px;
    margin-right: 1em;
    border-radius: 10px;
    border: 1px solid #efefef;
    &.red {
      background-color: #f34424;
    }
    &.blue {
      background-color: #333333;
    }
    &.black {
      background-color: #000;
    }
    &.green {
      background-color: #3d8116;
    }
  }
}
</style>

<style lang="scss">
.fontsize {
  padding: 5%;
  font-size: 40px;
  max-width: 247px;
}
.no-address-block {
  .image {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: #edeff5;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    img {
      width: 50px;
    }
  }
  p {
    color: rgba(29, 28, 29, 0.4);
    line-height: 23px;
  }
  .el-upload {
    img {
      max-width: 150px;
    }
  }
  .el-button.is-circle {
    font-size: 10px !important;
  }
}
.preview-image {
  min-width: 30px;
}
.el-image__error,
.el-image__inner,
.el-image__placeholder {
  width: unset !important;
}
.signature-box {
  .el-tabs {
    margin-top: 0 !important;
  }
  .el-tabs__item {
    font-size: 1.1em;
    &:hover {
      color: #000000;
    }
    &.is-active {
      color: #f754a2;
      background-color: #ffffff;
    }
  }
  .el-tabs__active-bar {
    background-color: #f754a2;
  }
  .el-tabs__nav-wrap::after {
    background-color: #ffffff;
  }
}
.signature-box-type-two {
  margin-bottom: 0px !important;
  .card {
    margin-bottom: 5px !important;
  }
}
.avatar-uploader {
  border: 1px dashed #409eff;
  background-color: #f7f9ff;
}
</style>
